module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/Rectangle 508.4738a155.png";